if (!customElements.get('size-guide')) {
  class SizeGuide extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init() {
      this.buttons = this.querySelectorAll('[toggle-size-drawer]');
      this.buttons?.forEach(button => {
        button?.addEventListener('click', () => {
          const drawer = this.closest('product-info')?.querySelector('size-guide-drawer');
          drawer.dispatchEvent(new CustomEvent('toggle-drawer', {
            bubbles: true,
            composed: true
          }));
        });
      });
    }
  }
  customElements.define('size-guide', SizeGuide);
}

if (!customElements.get('size-guide-drawer')) {
  class SizeGuideDrawer extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init() {
      this.drawer = this.querySelector('[size-guide-drawer]');
      this.buttons = this.querySelectorAll('[toggle-size-drawer]');

      this.addEventListener('toggle-drawer', () => {
        this.toggleDrawer();
      });


      this.buttons?.forEach(button => {
        button?.addEventListener('click', () => {
          this.toggleDrawer();
        });
      });
    }
    toggleDrawer() {
      if (this.drawer.classList.contains('active')) {
        this.closeDrawer();
      } else {
        this.openDrawer();
      }
    }
    openDrawer() {
      this.drawer.classList.add('active');
      setTimeout(() => {
        this.drawer.classList.add('is-active');
      }, 100);
    }
    closeDrawer() {
      this.drawer.classList.remove('is-active');
      setTimeout(() => {
        this.drawer.classList.remove('active');
      }, 100);
    }
  }
  customElements.define('size-guide-drawer', SizeGuideDrawer);
}